import Index from './index'
import Listar from './Listar'
import Detalhes from './Detalhes'
import Relatorio from './Relatorio'

const route = {
  path: '/apuracao-mensal',
  name: 'apuracao-mensal',
  component: Index,
  children: [
    { path: 'listar', name: 'apuracao-mensal-listar', component: Listar },
    { path: 'listar-apuradas', name: 'apuracao-mensal-listar-apuradas', component: Listar, props: { titulo: 'Listar Apuradas', status: 3 } },
    { path: 'listar-aguardando-validacao', name: 'apuracao-mensal-listar-aguardando-validacao', component: Listar, props: { titulo: 'Listar Aguardando Validação', status: 2 } },
    { path: 'listar-rejeitadas', name: 'apuracao-mensal-listar-rejeitadas', component: Listar, props: { titulo: 'Listar Rejeitadas', status: 4 } },
    { path: 'relatorio', name: 'apuracao-mensal-relatorio', component: Relatorio, props: true },
    { path: ':id', name: 'apuracao-mensal-detalhes', component: Detalhes, props: true }
  ],
  meta: { requiresAuth: true }
}

export default route



// WEBPACK FOOTER //
// ./src/pages/apuracao-mensal/routes.js